<template>
<div id="app" class="app">
  <router-view/>
</div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {}
  }
}
</script>

<style lang="scss">
.app {
  height: 100vh;
}
</style>
